import { render, staticRenderFns } from "./JoinLink.vue?vue&type=template&id=31cc81a0"
import script from "./JoinLink.vue?vue&type=script&lang=js"
export * from "./JoinLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports